import React from "react";
import cx from "classnames";

const Label = ({ htmlFor, Icon, children, iconClassName }) => (
    <label
        htmlFor={htmlFor}
        className="mb-3 flex items-center text-base font-medium text-gray-700"
    >
        {Icon && <Icon className={iconClassName || "mr-2 h-5 w-5"} aria-hidden="true" />}
        {children}
    </label>
);
const Field = ({ className, touched, valid, children }) => (
    <div
        className={cx(
            {
                "has-success group": touched && valid,
                "has-error group": touched && !valid,
            },
            className
        )}
    >
        {children}
    </div>
);
const Error = ({ className, error }) => (
    <p className={cx("mt-2 text-sm text-red-600", className)}>{error}</p>
);
export { Field, Label, Error };
